import React, { Component } from 'react';
import Header from "../component/header/Header";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Footer from "../component/footer/FooterTwo";
import Helmet from "../component/common/Helmet";

class error404 extends Component {

    render() {
        return (
            <>
                {/* <Header headerPosition="header--transparent" color="color-white" logo="logo-light" /> */}
                <Helmet pagetitle="404: Página no encontrada" description="Página no encontrada" noindex nofollow >
                    <title>404: Página no encontrada</title>


                </Helmet>
                <Header
                    headerPosition="header--static bg_color--6"
                    logo="symbol-dark"
                    color="color-white"

                />
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">404!</h1>
                                    <h3 className="sub-title">Página no encontrada</h3>
                                    <span>La página que estabas buscando no existe</span>
                                    <div className="error-button">
                                        <a className="btn-default" href="/">Volver</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </>
        )
    }
}
export default error404;
